import { CommonModule } from '@angular/common';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class MultilineFileUploadModule {
}
MultilineFileUploadModule.ɵfac = function MultilineFileUploadModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultilineFileUploadModule)(); };
MultilineFileUploadModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MultilineFileUploadModule });
MultilineFileUploadModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule] });
